import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import DatePicker from 'react-datepicker2';
import SelectAsync from 'react-select/async';

export default class Start extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true,
			tab: 1,
			date: new Date().toString(),
			moeinCode: 0,
			description: '',
		}
	}
	componentDidMount() {
		this.httpPost("api/v1/document/getstart")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e) {
		if (this.isBlank(this.state.moeinCode)) this.state.moeinCode = 0;

		this.httpPost("api/v1/document/start", {
			moeinCode: this.state.moeinCode,
			description: this.state.description,
			date: this.convertMomentToDb(this.state.date),
			organizationId: this.state.data.global.company.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("سند افتتاحیه با موفقیت صادر شد");
					this.setState({ redirect: "/documents/" });
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="row center-block" id="accBalances">
			<div className="bs-callout bs-callout-default" id="openingBalancePageHeader">
				<div className="row">
					<div className="col-sm-12">
						<h4 style={{ "display": "inline-block" }}>مانده اول دوره حساب ها - صدور سند افتتاحیه</h4>
					</div>
					<div className="col-sm-3">
						<div className="form-group form-inline">
							<label>معین افتتاحیه: </label>
							<SelectAsync
								style={{ "width": "100%" }}
								defaultValue={null}
								isMulti={false}
								placeholder="انتخاب معین افتتاحیه"
								defaultOptions
								loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
								onChange={e => this.state.moeinCode = e.value}
							/>
						</div>
					</div>
					<div className="col-sm-2">
						<div className="form-group form-inline">
							<label>تاریخ سند: </label>
							<DatePicker
								inputReadOnly={true}
								className="form-control input-sm persian-date"
								placeholder={"تاریخ"}
								isGregorian={false}
								showTodayButton={true}
								timePicker={false}
								onChange={(e) => { this.state.date = e }}
								value={this.getFormatedDateForDatePicker(this.state.date)}
							/>
						</div>
					</div>
					<div className="col-sm-6">
						<div className="form-group">
							<label for="documentDescription" className="title1">شرح</label>
							<input onChange={e => this.state.description = e.target.value} defaultValue={this.state.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
						</div>
					</div>
					<div className="col-sm-1 text-left">
						<button onClick={e => this.save()} className="btn btn-success btn-sm" style={{ "width": "80px" }}>صدور</button>
					</div>
				</div>
				<div className="row">
					<ul className="nav nav-tabs mt-n3">
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 1 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>صندوقها</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 2 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>حسابهای بانکی</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 3 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>بدهکاران (حسابهای دریافتنی)</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 4 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>بستانکاران (حسابهای پرداختنی)</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 5 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>موجودی کالا (موجودی اول دوره)</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 6 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>چک های صادره (اسناد پرداختنی)</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 7 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>چک های دریافتی (اسناد دریافتنی)</span></a>
						</li>
						<li className="nav-item">
							<a onClick={e => this.setState({ tab: 8 })} className="hand nav-link"><em className="icon ni ni-list-round"></em><span>چک های در جریان وصول</span></a>
						</li>
					</ul>
					<div className="tab-content">
						{this.state.tab === 1 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: this.state.data.cashdesks,
								columnDefs: [
									{ field: "name", headerName: "نام صندوق" },
									{ field: "code", headerName: "تفصیل" },
									{ field: "firstAnnualRemain", headerName: "مانده اولیه" }
								]
							})}
						</div>}
						{this.state.tab === 2 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: this.state.data.bankaccounts,
								columnDefs: [
									{ field: "name", headerName: "نام بانک" },
									{ field: "code", headerName: "تفصیل" },
									{ field: "firstAnnualRemain", headerName: "مانده اولیه" }
								]
							})}
						</div>}
						{this.state.tab === 3 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: this.state.data.customers,
								columnDefs: [
									{ field: "name", headerName: "مشتری" },
									{ field: "code", headerName: "تفصیل" },
									{ field: "customerFirstAnnualRemain", headerName: "مبلغ بدهی" }
								]
							})}
						</div>}
						{this.state.tab === 4 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: this.state.data.suppliers,
								columnDefs: [
									{ field: "name", headerName: "تامین کننده" },
									{ field: "code", headerName: "تفصیل" },
									{ field: "supplierFirstAnnualRemain", headerName: "مبلغ بستانکاری" }
								]
							})}
						</div>}
						{this.state.tab === 5 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: [],
								columnDefs: [
									{ field: "", headerName: "کالا" },
									{ field: "", headerName: "انبار" },
									{ field: "", headerName: "واحد" },
									{ field: "", headerName: "تعداد" },
									{ field: "", headerName: "قیمت واحد" },
									{ field: "", headerName: "قیمت کل" }
								]
							})}
						</div>}
						{this.state.tab === 6 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: [],
								columnDefs: [
									{ field: "", headerName: "شخص دریافت کننده" },
									{ field: "", headerName: "شماره چک" },
									{ field: "", headerName: "مبلغ چک" },
									{ field: "", headerName: "تاریخ سررسید" },
									{ field: "", headerName: "در وجه" }
								]
							})}
						</div>}
						{this.state.tab === 7 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: [],
								columnDefs: [
									{ field: "", headerName: "شخص صادر کننده" },
									{ field: "", headerName: "شماره چک" },
									{ field: "", headerName: "مبلغ چک" },
									{ field: "", headerName: "بانک" },
									{ field: "", headerName: "شعبه" },
									{ field: "", headerName: "تاریخ سررسید" }
								]
							})}
						</div>}
						{this.state.tab === 8 && <div className="tab-pane active">
							{this.renderAgGrid({
								records: [],
								columnDefs: [
									{ field: "", headerName: "شخص صادر کننده" },
									{ field: "", headerName: "شماره چک" },
									{ field: "", headerName: "مبلغ چک" },
									{ field: "", headerName: "بانک" },
									{ field: "", headerName: "شعبه" },
									{ field: "", headerName: "تاریخ چک" },
									{ field: "", headerName: "بانک در جریان وصول" },
									{ field: "", headerName: "تاریخ واگذاری" }
								]
							})}
						</div>}
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}